var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/arrow.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.$t(_vm.title)))]), _c("div", {
    staticClass: "img-wrap"
  })]), _c("div", {
    staticClass: "main"
  }, [_vm._l(_vm.questions, function (item, index) {
    return _c("div", {
      key: item.id,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toAnswer(item.id);
        }
      }
    }, [_c("div", {
      staticClass: "left"
    }, [index % 3 == 0 ? _c("img", {
      attrs: {
        src: require("../../assets/images/ic_questionnaire_copy1.png"),
        alt: ""
      }
    }) : _vm._e(), index % 3 == 1 ? _c("img", {
      attrs: {
        src: require("../../assets/images/ic_questionnaire_copy2.png"),
        alt: ""
      }
    }) : _vm._e(), index % 3 == 2 ? _c("img", {
      attrs: {
        src: require("../../assets/images/ic_questionnaire_copy3.png"),
        alt: ""
      }
    }) : _vm._e(), item.is_finish == 1 ? _c("div", {
      staticClass: "submitted"
    }, [_c("span", [_vm._v(" " + _vm._s(_vm.$t("Submitted")) + " ")])]) : _vm._e()]), _c("div", {
      staticClass: "right"
    }, [_c("span", {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.title))]), _c("span", {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.questionNum) + " " + _vm._s(_vm.$t("Questions")))])])]);
  }), _vm.questions.length == 0 ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" " + _vm._s(_vm.$t("NoData")) + " ")]) : _vm._e()], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };